var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusPurple = function SvgPlusPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.726 14.55.05-10.97c0-.611-.56-1.173-1.173-1.173h-2.551c-.612 0-1.174.562-1.174 1.174l.051 10.97H2.91c-.613 0-1.174.561-1.174 1.173v2.552c0 .612.561 1.173 1.173 1.173l10.97-.05v11.02c0 .612.562 1.174 1.174 1.174h2.551c.612 0 1.174-.562 1.174-1.174V19.4l10.97.05c.612 0 1.173-.561 1.173-1.173v-2.552c0-.612-.561-1.173-1.173-1.173H18.726Z",
    fill: "url(#plus-purple_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plus-purple_svg__a",
    x1: 0.879,
    y1: 25.164,
    x2: 24.491,
    y2: 25.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1e215b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e215b"
  })))));
};
export default SvgPlusPurple;